import * as React from 'react';

import { Tooltip } from '@/components/Atoms/Tooltip/Tooltip';
import { Button } from '@/components/Button/Button';
import { IconButton } from '@/components/IconButton/IconButton';
import { Modal, ModalBody, ModalFooter } from '@/components/Modal/Modal';
import AskNeedlNewChatPlusIcon from '@/icons/askneedl-new-chat-plus.svg?react';

export const ClearButton = ({
  className,
  disabled,
  onClick,
  showConfirmation = false,
  modalBody = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
}: ClearButtonType) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleClick = () => {
    if (showConfirmation) {
      setIsModalOpen(true);
    } else {
      onClick();
    }
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    onClick();
  };

  return (
    <div className={className}>
      <Tooltip label='New Topic'>
        <IconButton
          label='new topic'
          disabled={disabled}
          onClick={handleClick}
          size='xl'
        >
          <AskNeedlNewChatPlusIcon />
        </IconButton>
      </Tooltip>

      {showConfirmation ? (
        <Modal
          showDialog={isModalOpen}
          onDismiss={() => setIsModalOpen(false)}
          ariaLabel='confirmation-modal'
        >
          <ModalBody>
            <div className='text-gray-700 p-2'>{modalBody}</div>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='secondary'
              size='medium'
              onClick={() => setIsModalOpen(false)}
              label={cancelLabel}
            />
            <Button
              variant='primary'
              size='medium'
              onClick={handleConfirm}
              label={confirmLabel}
            />
          </ModalFooter>
        </Modal>
      ) : null}
    </div>
  );
};

export type ClearButtonType = {
  className?: string;
  disabled: boolean;
  onClick: () => void;
  showConfirmation?: boolean;
  modalBody?: string;
  confirmLabel?: string;
  cancelLabel?: string;
};
